import {
	createTheme,
} from '@mui/material'

import {
	materialUICommonTheme,
	materialUIPaletteTheme,
} from '../common'
import {
	materialUIAccordionTheme,
	materialUIAppBarTheme,
	materialUIAvatarTheme,
	materialUIBadgeTheme,
	materialUIBottomNavigationTheme,
	materialUIButtonTheme,
	materialUICardTheme,
	materialUICheckboxTheme,
	materialUIChipTheme,
	materialUIContainerTheme,
	materialUIDialogTheme,
	materialUIDividerTheme,
	materialUIFormControlTheme,
	materialUIInputTheme,
	materialUILinearTheme,
	materialUILinkTheme,
	materialUIListTheme,
	materialUILoaderTheme, materialUIMenuTheme,
	materialUIPaginationTheme,
	materialUIPaperTheme,
	materialUISelectTheme,
	materialUISkeletonTheme, materialUISpeedDialTheme,
	materialUIStepperTheme,
	materialUISVGIconTheme,
	materialUISwitchTheme,
	materialUITableTheme,
	materialUITabsTheme,
	materialUIToggleButtonGroupTheme,
	materialUITypographyComponentTheme,
	materialUITypographyTheme,
} from '../components'

export const materialUICoreTheme = createTheme(

	/* components */
	materialUIChipTheme,
	materialUIListTheme,
	materialUITabsTheme,
	materialUILinkTheme,
	materialUICardTheme,
	materialUIMenuTheme,
	materialUIBadgeTheme,
	materialUITableTheme,
	materialUIPaperTheme,
	materialUIInputTheme,
	materialUILoaderTheme,
	materialUIAvatarTheme,
	materialUISwitchTheme,
	materialUILinearTheme,
	materialUIDialogTheme,
	materialUIAppBarTheme,
	materialUIButtonTheme,
	materialUISelectTheme,
	materialUIStepperTheme,
	materialUIPaletteTheme,
	materialUISVGIconTheme,
	materialUIDividerTheme,
	materialUISkeletonTheme,
	materialUICheckboxTheme,
	materialUIAccordionTheme,
	materialUISpeedDialTheme,
	materialUIContainerTheme,
	materialUIPaginationTheme,
	materialUITypographyTheme,
	materialUIFormControlTheme,
	materialUIBottomNavigationTheme,
	materialUIToggleButtonGroupTheme,
	materialUITypographyComponentTheme,

	/* must always be at the end */
	materialUICommonTheme,
)
